const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d57acba05ea608201e9670be3e40cfe6ed2cf87b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["northern-light@long-forme"]={id:"d57acba05ea608201e9670be3e40cfe6ed2cf87b"};
      